import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from './LinkedInSidebar';
import { useLocation } from 'react-router-dom';
import { Bell, BellOff } from "lucide-react";
import Modal from './Elements/Modal';
import axios from "axios";
import Cookies from "js-cookie";

const NotificationsPage = ({ currentPage, setCurrentPage, setTitleDescription, openCompanyPage, authStatus }) => {
  const [totalPages, setTotalPages] = useState(20);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [isOpenDisableAllNotifications, setIsOpenDisableAllNotifications] = useState(false);
  const [loadingDisableAll, setLoadingDisableAll] = useState(false);
  const [loading, setLoading] = useState(true);
  
  

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPageNum(pageNumber);
  };

  // Function to handle Next button click
  const nextPage = () => {
    if (currentPageNum < totalPages) {
      setCurrentPageNum(currentPageNum + 1);
    }
  };

  // Function to handle Previous button click
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPageNum(currentPageNum - 1);
    }
  };

  // Determine which page numbers to show (max 5 page numbers)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const start = Math.max(currentPageNum - 2, 1); // Start page number (current page - 2)
    const end = Math.min(start + 4, totalPages); // End page number (start + 4)

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const [companyList, setCompanyList] = useState([]);
  
  // Assuming you're inside a component
  async function getCompanyNotificationList() {
    setLoading(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/notifications/get-company-list`, { token: Cookies.get('token'), page: currentPageNum });

      console.log("getCompanyNotificationList: ", response.data);

      if(response.data.status == 'ok') {
        setCompanyList(response.data.result);
        setTotalPages(response.data.max_page);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getCompanyNotificationList();
  }, [currentPageNum]);

  async function disableNotificationsForAllCompanies() {
    setLoadingDisableAll(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/notifications/disable-all-companies`, { token: Cookies.get('token') });

      if(response.data.status == 'ok') {
        setIsOpenDisableAllNotifications(false);
        getCompanyNotificationList();
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoadingDisableAll(false);
    }
  }

  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">

      <Modal isOpen={isOpenDisableAllNotifications} onClose={() => setIsOpenDisableAllNotifications(false)}>
        
        <p className="mt-5 text-md font-main-bold text-center">Are you sure you want to disable notifications for all companies?</p>

        <div className="flex items-center justify-center gap-4">
          <button
            className={`mt-4 px-4 py-2 bg-gray-500 text-white rounded ${loadingDisableAll == true ? 'opacity-50' : ''}`}
            onClick={() => disableNotificationsForAllCompanies()} // Добавлена проверка на существование setModalIsOpen
          >
            {loadingDisableAll == true && (
              <span>Loading...</span>
            )}
            {loadingDisableAll == false && (
              <span>Disable</span>
            )}
          </button>

          <button
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
            onClick={() => setIsOpenDisableAllNotifications && setIsOpenDisableAllNotifications(false)} // Добавлена проверка на существование setModalIsOpen
          >
            Close
          </button>
        </div>

      </Modal>
      
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3 space-y-6">
            {/* Page Header */}
            <div className="linkedin-card">
              <div className="linkedin-card-content">
                <div className="text-left mb-4">
                  <h1 className="text-3xl font-bold text-gray-900">Notifications</h1>
                  <p className="text-md text-gray-600">
                    Receive notifications about top-performing companies and the best investment opportunities - right when it matters most.
                  </p>
                </div>
                
                <div className="border-t border-gray-200 pt-4">
                  <h2 className="text-xl font-bold text-gray-900">Company notifications</h2>
                  <p className="text-sm text-gray-600 mb-6">
                    Here is the list of companies for which you've enabled notifications. 
                    When a company's parameters match your filter settings, you'll receive a notification via email.
                  </p>
                  
                  <button onClick={() => setIsOpenDisableAllNotifications(true)} className={`linkedin-btn-primary text-sm text-white rounded-lg flex justify-center items-center`}>
                    <BellOff className="text-white w-4 h-4 mr-2" />
                    Disable Notifications for All Companies
                  </button>

                </div>
              </div>
            </div>

            {/* Notifications Table */}
            <div className="linkedin-card">
              <div className="linkedin-card-header">
                <h3 className="text-lg font-bold text-gray-900">
                  Active Notification Companies ({companyList.length})
                </h3>
              </div>
              <div className="linkedin-card-content">

                {loading === true && (
                  <div className="lg:col-span-3 space-y-6">
                    <div className='mx-auto w-fit'>
                      <button className="linkedin-action-btn" disabled={loading}>
                        <span>Loading...</span>
                      </button>
                    </div>
                  </div>
                )}

                {loading === false && (
                  <>
                    {companyList.length === 0 ? (
                      <div className="text-center py-4">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">No Active Notifications</h3>
                        <p className="text-sm text-gray-600 mb-4">
                          You haven't enabled notifications for any companies yet. 
                          Visit company pages to set up notifications.
                        </p>
                        <button 
                          onClick={() => setCurrentPage('search')}
                          className="linkedin-btn-primary"
                        >
                          Browse Companies
                        </button>
                      </div>
                    ) : (
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead>
                            <tr className="border-b border-gray-200">
                              <th className="text-left py-3 px-4 font-semibold text-gray-900">Company</th>
                              <th className="text-left py-3 px-4 font-semibold text-gray-900">Sector</th>
                              <th className="text-left py-3 px-4 font-semibold text-gray-900">Success Rate</th>
                            </tr>
                          </thead>
                          <tbody>
                            {companyList.map((company) => (
                              <tr key={company.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                                <td className="py-4 px-4">
                                  <div onClick={() => openCompanyPage(company)} className="flex items-center space-x-3 cursor-pointer">
                                    <div className="w-14 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                                      <img src={company.image} />
                                    </div>
                                    <div>
                                      <p className="text-sm font-semibold text-gray-900">{company.company_name}</p>
                                    </div>
                                  </div>
                                </td>
                                <td className="py-4 px-4">
                                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                    {company.sector}
                                  </span>
                                </td>
                                <td className="py-4 px-4">
                                  <div className="flex items-center space-x-2">
                                    <span className={`text-xs font-medium ${
                                      company.success_rate >= 85 ? 'text-blue-600' : 
                                      company.success_rate >= 70 ? 'text-blue-600' : 'text-blue-600'
                                    }`}>
                                      {company.success_rate}%
                                    </span>
                                    <div className="w-16 bg-gray-200 rounded-full h-2">
                                      <div 
                                        className={`h-2 rounded-full ${
                                          company.success_rate >= 85 ? 'bg-blue-500' : 
                                          company.success_rate >= 70 ? 'bg-blue-500' : 'bg-blue-500'
                                        }`}
                                        style={{ width: `${company.success_rate}%` }}
                                      ></div>
                                    </div>
                                  </div>
                                </td>
                                {/* <td className="py-4 px-4">
                                  <div className="flex items-center space-x-2 justify-center">
                                    <button 
                                      onClick={() => openCompanyPage(company)}
                                      className="text-linkedin-blue hover:text-blue-700 text-sm font-medium"
                                      title="View Company Details"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                    </button>
                                    <button 
                                      onClick={() => handleRemoveNotification(company.id)}
                                      className="text-red-600 hover:text-red-700 text-sm font-medium"
                                      title="Remove Notification"
                                    >
                                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                      </svg>
                                    </button>
                                  </div>
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}

                
              </div>
            </div>

            {/* Notification Settings Help */}
            {companyList.length > 0 && (
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h3 className="text-lg font-bold text-gray-900">How Notifications Work</h3>
                </div>
                <div className="linkedin-card-content">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h4 className="font-semibold text-gray-900 mb-2">📧 Email Notifications</h4>
                      <p className="text-sm text-gray-600">
                        You'll receive email alerts when a company's financial metrics match your specified criteria.
                      </p>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h4 className="font-semibold text-gray-900 mb-2">⚡ Real-time Updates</h4>
                      <p className="text-sm text-gray-600">
                        Notifications are sent as soon as we detect changes in the company's performance metrics.
                      </p>
                    </div>
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <h4 className="font-semibold text-gray-900 mb-2">🎯 Custom Filters</h4>
                      <p className="text-sm text-gray-600">
                        Set specific success rate ranges and choose which financial metrics to monitor.
                      </p>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg">
                      <h4 className="font-semibold text-gray-900 mb-2">📊 Performance Tracking</h4>
                      <p className="text-sm text-gray-600">
                        Track how your notification settings perform and adjust them for better results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;